<template>
    <v-menu :close-on-content-click="false" offset-y>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                    class="font-weight-bold text-none text-caption filter"
                    depressed
                    plain
                    retain-focus-on-click
                    v-bind="attrs"
                    v-on="on">
                {{ name }}
                <v-icon>
                    mdi-menu-down
                </v-icon>
            </v-btn>
        </template>
        <v-list class="filter-list secondary">
            <v-list-item class="secondary">
                <v-list-item-title>
                    <v-checkbox
                            v-model="selectAll"
                            :label="'('+$t('selectAll') + ')'"
                            class="my-2 body-2"
                            hide-details
                    ></v-checkbox>
                </v-list-item-title>
            </v-list-item>
            <v-list-item
                    v-for="(item, index) in sortedFilterValues"
                    :key="index"
                    class="secondary">
                <v-list-item-title>
                    <v-checkbox
                            v-model="selected"
                            :label="item.text"
                            :value="item.value"
                            class="my-2 body-2"
                            hide-details
                    ></v-checkbox>
                </v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
import {sortByAlphabetical} from "@/helper/helper";

export default {
  name: "FilterDropDown",
  props: {
    filterValues: {
      type: Array,
      required: true,
    },
    value: {
      type: Array,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    availableValues: {
      type: Array,
      required: false,
      default: () => [],
    }
  },
  mounted() {
    if (this.value && this.value.length) {
      this.selected = this.value;
    } else {
      this.selected = this.filterValues.map(value => value.value);
    }
  },
  data() {
    return {
      selected: [],
      selectAll: true,
    };
  },
  computed: {
    sortedFilterValues() {
      let tmpValues = this.filterValues;
      tmpValues = tmpValues.filter(value => !this.availableValues.length || this.availableValues.includes(value.value));
      return tmpValues.sort(sortByAlphabetical('text'));
    }
  },
  watch: {
    selected(value) {
      if (Array.isArray(value)) {
        this.$emit('input', value);
      } else {
        this.$emit('input', []);
      }
    },
    filterValues(values) {
      this.selected = values.map(value => value.value);
    },
    selectAll(val) {
      if (val) {
        this.selected = this.filterValues.map(value => value.value);
      } else {
        this.selected = [];
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import "filter-drop-down";
</style>